<template>
	<div class="subfactor-item tw-p-2 custom-fade-in">
		<div class="tw-flex tw-justify-between tw-items-center tw-gap-1 tw-pb-3">
			<span class="text-lg"
				><b>{{ subItem.description }}</b>
			</span>
			<div class="tw-flex tw-gap-x-4">
				
				<div class="tw-flex tw-items-center">
					<p-button
						type="primary"
						size="small"
						roundedLevel="rounded"
						@click="addClicked()">Añadir Pregunta</p-button>
				</div>
			</div>
		</div>
		<p-horizontal-divider mx="-1rem" my="0" />
		<section class="tw-flex tw-flex-col tw-pb-2">
			<questions-sortable-list
				:questions="subItem.questions || []"
				@onSortedQuestionsChange="handleSortableQuestions($event, subItem)"
				@removeClicked="handleRemoveQuestion($event, subItem)"
				@editClicked="handleEditQuestion($event, subItem)">
			</questions-sortable-list>
		</section>
		<p-horizontal-divider mx="-1rem" my="0" />
		<div class="sub-cores tw-flex tw-gap-1 tw-justify-center tw-items-center">
			<div v-for="(equivalence, indexE) in subItem.equivalences">
				<label :key="indexE" :style="`color:${$appColors.info};`">
					{{ equivalence.code }}
					<input
						class="sub-cores-input"
						type="number"
						:value="equivalence.value"
						@input="changeValueEquivalence($event, indexE, equivalence)"
					/>
				</label>
			</div>
			<div class="tw-justify-items-end" style="padding-top: 20px;">
				<app-tooltip-button
					v-if="toolTip"
					size="16"
					text="La suma de todos los valores de Ex debe sumar 100%"
					img="/static/img/question-circle.svg"
					disabled
				></app-tooltip-button>
			</div>
		</div>
		<add-question-dialog
			ref="actionQuestionsAdd"
			:selected-question="selectedQuestion"
			:flagEditItem="flagEditItem"
			@handleAddNewQuestion="handleAddNewQuestion($event, subItem)">
		</add-question-dialog>
	</div>
</template>

<script>
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import addIcon from '@/modules/shared/components/icons/add-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import questionsSortableList from '@/modules/recruitment/components/content/questions-sortable-list';
import addQuestionDialog from '@/modules/recruitment/components/content/add-question-dialog';
import { clone, assoc } from 'ramda';
import { removeItemList } from '@/modules/recruitment/utils/listElements';

export default {
	name: 'subfactor-item',
	data() {
		return {
			focusedSubFactor: {},
			selectedQuestion: {},
			flagEditItem: false,
		};
	},
	components: { PHorizontalDivider, addIcon, PButton, questionsSortableList, addQuestionDialog },
	methods: {
		addClicked() {
			this.selectedQuestion = {};
			this.flagEditItem = false;
			this.$refs.actionQuestionsAdd.open();
		},
		handleAddNewQuestion(question, subFactor) {
			this.flagEditItem = false;
			const newQuestion = clone(question);
			this.focusedSubFactor = subFactor;
			this.focusedSubFactor.questions.push(
				newQuestion,
			);
		},
		handleRemoveQuestion(selectedQuestion, subFactor) {
			this.focusedSubFactor = subFactor;
			const updateQuestions = removeItemList(
				selectedQuestion,
				subFactor.questions,
			);
			const updateSubFactor = assoc('questions', updateQuestions, this.focusedSubFactor);
			this.$emit('updateSubFactorItem', updateSubFactor);
		},
		handleEditQuestion(selectedQuestion, subFactor) {
			this.focusedSubFactor = subFactor;
			this.selectedQuestion = selectedQuestion;
			this.flagEditItem = true;
			this.$refs.actionQuestionsAdd.open();
		},
		changeValueEquivalence(value, index) {
			const valueInput = Number(value.target.value);
			if (index === 0) {
				if (valueInput === 0) {
					this.$set(this.subItem.equivalences[index], 'value', valueInput);
				} else {
					this.$set(this.subItem.equivalences[index], 'value', valueInput);
					this.showNotification('El valor no puede ser diferente a cero', 'warning');
				}
			} else if (index === 1) {
				if (this.subItem.equivalences[index + 1].value === null) {
					if (valueInput > this.subItem.equivalences[index - 1].value) {
						this.$set(this.subItem.equivalences[index], 'value', valueInput);
					} else {
						this.showNotification('El valor no puede ser menor que el anterior', 'warning');
					}
				} else {
					// eslint-disable-next-line
					if (valueInput < this.subItem.equivalences[index - 1].value) {
						this.showNotification('El valor no puede ser menos al anterior', 'warning');
					} else if (valueInput > this.subItem.equivalences[index + 1].value) {
						this.showNotification('El valor no puede ser mayor al siguiente', 'warning');
					} else if (valueInput > this.subItem.equivalences[index - 1].value
						|| valueInput < this.subItem.equivalences[index + 1].value) {
						this.$set(this.subItem.equivalences[index], 'value', valueInput);
					}
				}
			} else if (index === 2) {
				if (this.subItem.equivalences[index + 1].value === null) {
					if (valueInput > this.subItem.equivalences[index - 1].value) {
						this.$set(this.subItem.equivalences[index], 'value', valueInput);
					} else {
						this.showNotification('El valor no puede ser menor que el anterior', 'warning');
					}
				} else {
					// eslint-disable-next-line
					if (valueInput < this.subItem.equivalences[index - 1].value) {
						this.showNotification('El valor no puede ser menos al anterior', 'warning');
					} else if (valueInput > this.subItem.equivalences[index + 1].value) {
						this.showNotification('El valor no puede ser mayor al siguiente', 'warning');
					} else if (valueInput > this.subItem.equivalences[index - 1].value
						|| valueInput < this.subItem.equivalences[index + 1].value) {
						this.$set(this.subItem.equivalences[index], 'value', valueInput);
					}
				}
			} else if (index === 3) {
				if (valueInput > this.subItem.equivalences[index - 1].value) {
					this.$set(this.subItem.equivalences[index], 'value', valueInput);
				} else {
					this.$set(this.subItem.equivalences[index], 'value', valueInput);
					this.showNotification('El valor no puede ser menor que el anterior', 'warning');
				}
			}
		},
	},
	props: {
		subItem: {
			type: Object,
			default: {},
		},
		toolTip: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
	},

};
</script>

<style lang="scss" scoped>
.subfactor-item {
	border: 1px solid var(--app-color-gray);
	border-radius: 10px;
	span {
		color: map-get($colors, gray-sidebar);
		font-size: 16px !important;
	}
}
.sub-cores {
	width: 100%;
	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, placeholder);
		border-radius: 4px;
        display: block;
        outline: none;
		color: map-get($colors, secondary);
		padding: 5px;
		width: 100px;
		text-align: center;
		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/subfactor-item.vue